export default __webpack_public_path__ + "static/media/contact-us-img-01.68ed93a8.jpg";